import { CommonUtils } from "../common/util/CommonUtils";
import Logger from "../common/util/Logger";
import { DC_SERVICE_API_KEYS } from "../common/constants/CommonConstants";

const loggerInstance = new Logger(
  "Signup confirmation responsive Connector",
  "Sfly-Signup-Confirmation-Responsive"
);
export class Connector {
  constructor(dispatch) {
    const useMocks = false;
    this.commonUtils = new CommonUtils(useMocks, dispatch);
    const serviceURL = `//api2.${this.commonUtils.getEnvPrefix()}shutterfly.com/v1/services-dynamic-content/v1/dynamic-content/batch?contentSpaces=`;

    this.baseURL = useMocks
      ? "/mocks/signupConfirmationResponsive/"
      : serviceURL;

    this.config = {
      headers: {
        "SFLY-ApiKey":
          this.commonUtils.getEnvPrefix() !== ""
            ? DC_SERVICE_API_KEYS.NON_PROD
            : DC_SERVICE_API_KEYS.PROD
      }
    };

    this.dcList = [
      "responsive_signup_confirm_page_banner_cs",
      "responsive_signup_confirm_page_products_cs",
      "responsive_signup_confirm_page_sfly_applinks_cs"
    ];
  }

  /** @description
   * This method will fetch signup confirmation page dc's content objects
   */

  fetchAllDCs() {
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + this.dcList.join(","), this.config)
        .then(response => response.json())
        .then(
          response => {
            resolve(response);
          },
          error => {
            loggerInstance.error(
              "Failed to retrieve signup confirmation dcs data from endpoint. Using fallback config. ",
              error
            );
            reject(error);
          }
        );
    });
  }

  /** @description
   * This method is used to parse dcResponses and build object which will get bind to state
   */
  parseDcResponse(contentList) {
    const result = {};
    for (let i = 0; i < contentList.length; i++) {
      if (
        contentList[i].contentSpace ===
        "responsive_signup_confirm_page_banner_cs"
      ) {
        result.banner = this.commonUtils.convertToJSON(
          contentList[i].dynamicContent,
          "of responsive_signup_confirm_page_banner_cs dc"
        );
      } else if (
        contentList[i].contentSpace ===
        "responsive_signup_confirm_page_products_cs"
      ) {
        result.productCards = this.commonUtils.convertToJSON(
          contentList[i].dynamicContent,
          "of responsive_signup_confirm_page_products_cs dc"
        );
      } else if (
        contentList[i].contentSpace ===
        "responsive_signup_confirm_page_sfly_applinks_cs"
      ) {
        result.footerContent = this.commonUtils.convertToJSON(
          contentList[i].dynamicContent,
          "of responsive_signup_confirm_page_sfly_applinks_cs dc"
        );
      }
    }

    if (Object.keys(result).length > 0) {
      return result;
    } else {
      return null;
    }
  }

  errorLogger(msg, error) {
    loggerInstance.error(msg, error);
  }
}
